import { LocalNotifications } from '@capacitor/local-notifications';

async function init_local_notification(vue) {
  const permiso = await solicitarPermisoNotificacionesLocales();

  if (!permiso) {
    return;
  }

  LocalNotifications.addListener('localNotificationActionPerformed', (notification) => {
    if (notification.notification.extra.data.ruta) {
      vue.$router.push({ path: notification.notification.extra.data.ruta });
    }
  });
}

async function solicitarPermisoNotificacionesLocales() {
  let permStatus = await LocalNotifications.checkPermissions();

  const respuestasIgnoradas = ['denied', 'prompt'];
  if (respuestasIgnoradas.includes(permStatus.display)) {
    permStatus = await LocalNotifications.requestPermissions();
  }

  if (permStatus.display !== 'granted') {
    return false;
  }

  return true;
}

function show_local_notificacion(notification) {
  LocalNotifications.schedule({
    notifications: [
      {
        title: notification.title,
        body: notification.body,
        id: new Date().getTime(),
        iconColor: notification.data.color,
        extra: {
          data: notification.data,
        },
      },
    ],
  });
}

async function remover_local_notifications() {
  await LocalNotifications.removeAllListeners();
}

export { init_local_notification, show_local_notificacion, remover_local_notifications };
